import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { getFormatDate } from "~/libs/getFormatDate";
import { DefaultTextCell } from "~/shared/ui/TableV2/ui/Cells";
import { dateUTC } from "../helper";

export const getChecklistDetailColumns = (t: TFunction): ColumnsType<any> => [
  {
    title: t("pkd_checklists.table.percentage"),
    dataIndex: "percentage",
    key: "percentage",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("pkd_checklists.table.actualPoints"),
    dataIndex: "actualPoints",
    key: "actualPoints",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("pkd_checklists.table.maxPoints"),
    dataIndex: "maxPoints",
    key: "maxPoints",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("pkd_checklists.table.result"),
    dataIndex: "result",
    key: "result",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
];

export const getCommentsColumns = (t: TFunction): ColumnsType<any> => [
  {
    title: t("comment.table.text"),
    dataIndex: "text",
    key: "text",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("comment.table.author"),
    dataIndex: "author",
    key: "author",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("comment.table.createdAt"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (value: unknown) => (
      <DefaultTextCell text={value ? dateUTC(value) : ""} />
    ),
  },
];

export const getChecklistsColumns = (t: TFunction): ColumnsType<any> => [
  {
    title: t("pkd_checklists.table.id"),
    dataIndex: "id",
    key: "id",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("pkd_checklists.table.createdAt"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (value: unknown) => (
      <DefaultTextCell text={value ? getFormatDate(value, false) : ""} />
    ),
  },
  {
    title: t("pkd_checklists.table.name"),
    dataIndex: "name",
    key: "name",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
  {
    title: t("pkd_checklists.table.result"),
    dataIndex: "result",
    key: "result",
    render: (value: unknown) => <DefaultTextCell text={value} />,
  },
];
